<!--
 * @Description: ehs
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-04 17:39:06
 -->

<template>
      <v-list-item-content>
              <v-list-item-title>EHS 评分表</v-list-item-title>
              <v-card class="mx-auto" >
                    <v-card-text>
                    <p class="display-1 text--primary">
                       {{ ehs.score }} 分
                       <v-chip class="ma-2" color="red" text-color="white" v-if="ehs.score == 0"> 参考豆腐</v-chip>
                       <v-chip class="ma-2" color="orange" text-color="white" v-if="ehs.score == 1"> 参考剥皮香蕉 </v-chip>
                       <v-chip class="ma-2" color="light-green" text-color="white" v-if="ehs.score == 2"> 参考带皮香蕉 </v-chip>
                       <v-chip class="ma-2" color="green" text-color="white" v-if="ehs.score == 3"> 参考黄瓜 </v-chip>
                    </p>
                    <p>测分时间：{{ ehs.time | time }}</p>
                    <div class="text--primary">
                        1. 您的阴茎勃起硬度如何？<br>
                        <v-chip class="ma-2" :class="{'primary primary--text':ehs.score == 0}" outlined pill > 阴茎充血变大，但硬度不够，无法插入。（参考豆腐） </v-chip>
                        <br>
                        <v-chip class="ma-2" :class="{'primary primary--text':ehs.score == 1}" outlined pill > 阴茎有轻微勃起，但是未达到足以插入的硬度。（参考剥皮的香蕉） </v-chip>
                        <br>
                        <v-chip class="ma-2" :class="{'primary primary--text':ehs.score == 2}" outlined pill > 阴茎达到足以插入的硬度，但不够坚挺和持久。（参考带皮的香蕉） </v-chip>
                        <br>
                        <v-chip class="ma-2" :class="{'primary primary--text':ehs.score == 3}" outlined pill > 完全勃起而坚挺，而且够持久。（参考黄瓜） </v-chip>
                    </div>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-list-item-content>
</template>

<script>
export default {
    name:'EHS',
    props:{
        ehs:{
            score: Number,
            time: Number,
            user_id: Number
        }
    },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
</style>